import React, { ReactElement } from 'react';

//Components
import NodeConfigForm from './NodeConfigForm';

// Interfaces
import { NodeConfigInfo } from '../../../Interfaces/Config/NodeConfigInfo';
import { ApiEnums } from '../../../Interfaces/ApiEnums';
interface Props {
  isPageOpened: boolean;
  configSettingType: ApiEnums.ConfigSettingsType;
  handleClosePage: (open: boolean) => void;
  nodeConfigData: NodeConfigInfo;
}

const NodeConfigFormContainer: React.FC<Props> = ({
  isPageOpened,
  configSettingType,
  handleClosePage,
  nodeConfigData,
}): ReactElement => {
  const handleClose = () => {
    handleClosePage(false);
  };

  return (
    <div>
      {isPageOpened ? (
        <NodeConfigForm
          nodeConfigData={nodeConfigData}
          configSettingType={configSettingType}
          closePage={handleClose}
        />
      ) : null}
    </div>
  );
};

export default NodeConfigFormContainer;
